export default "__VITE_ASSET__CQp$kJ3G__"